import type { Epoch } from "../core/index.ts";

const MONTHS = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];

export function dayMonth(e: Epoch): { d: string; m: string } {
  if (e == null) return { d: "--", m: "" };
  const dt = new Date(e * 1000);
  return { d: String(dt.getUTCDate()).padStart(2, "0"), m: MONTHS[dt.getUTCMonth()] ?? "" };
}

export function longDate(e: Epoch): string {
  if (e == null) return "—";
  return new Date(e * 1000).toLocaleDateString(undefined, { year: "numeric", month: "long", day: "numeric", timeZone: "UTC" });
}

/** "Jun 19, 2026" — the compact form, for captions that must stay on one line. */
export function shortDate(e: Epoch): string {
  if (e == null) return "—";
  return new Date(e * 1000).toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric", timeZone: "UTC" });
}

export function fmt(v: number): string {
  return v >= 10 ? v.toFixed(1) : v.toFixed(2);
}

export const round0 = (v: number) => Math.round(v).toString();

/** epoch seconds -> "YYYY-MM-DD" (UTC) for <input type=date>. */
export function epochToDateInput(e: Epoch): string {
  const d = e != null ? new Date(e * 1000) : new Date();
  return d.toISOString().slice(0, 10);
}

/** "YYYY-MM-DD" -> epoch seconds at UTC midnight. */
export function dateInputToEpoch(s: string): number {
  const ms = Date.parse(`${s}T00:00:00Z`);
  return Number.isNaN(ms) ? Math.floor(Date.now() / 1000) : Math.floor(ms / 1000);
}
